/*
 * All You Can Play - ricerca in italiano di riserva.
 *
 * La ricerca di Shopify legge solo i testi in inglese (lingua principale del negozio).
 * Quando non trova prodotti, questo script cerca le stesse parole nell'elenco dei prodotti
 * in italiano (templates/collection.search-index.liquid) e mostra quello che trova:
 * - nella pagina dei risultati (/search), al posto di "Nessun risultato": tutti i prodotti trovati, nella griglia di
 *   sections/main-search.liquid, con la colonna dei filtri (assets/collection-filters.js) e "Mostra di più"
 *   (assets/collection-show-more.js), come i risultati di Shopify;
 * - nella tendina dei suggerimenti mentre si scrive, con accanto i "Suggerimenti": i giochi dei prodotti trovati.
 * Se Shopify trova prodotti, la pagina dei risultati resta quella di Shopify; nella tendina, se Shopify mostra meno di 4
 * prodotti, i posti liberi si riempiono con i prodotti che hanno nel titolo italiano tutte le parole cercate e che Shopify
 * non ha messo (per esempio un titolo tradotto da poco, che Shopify non ha ancora letto: "dominio" -> Dominio Delta).
 * Ordine, come snippets/aycp-ordine-ricerca.liquid per i risultati di Shopify: prima chi ha nel titolo tutta la frase
 * cercata, poi più parole cercate nel titolo, poi nel testo chiave; a parità disponibili, preordini, esauriti;
 * poi i più recenti.
 * L'elenco si scarica solo quando serve (quando si tocca una barra di ricerca) e una volta per visita.
 * I nomi dei "Suggerimenti": quelli dei giochi nella lingua della pagina (searchFallbackConfig.collectionTitles,
 * dal menu principale), gli altri (i set) da "ct" dell'elenco.
 * Le schede hanno lo stesso pulsante sotto il prezzo delle schede del tema (snippets/card-product.liquid):
 * Preordina, Avvisami, Scegli opzioni (aprono la pagina del prodotto) o Aggiungi al carrello (codice di Dawn, product-form.js).
 */
(function () {
  'use strict';

  var config = window.searchFallbackConfig;
  if (!config || !config.indexUrl) return;

  var STOP_WORDS = [
    'di', 'del', 'dello', 'della', 'dei', 'degli', 'delle', 'il', 'lo', 'la', 'i', 'gli', 'le', 'l',
    'un', 'uno', 'una', 'e', 'ed', 'o', 'a', 'al', 'allo', 'alla', 'ai', 'agli', 'alle', 'da', 'dal',
    'dalla', 'in', 'nel', 'nella', 'con', 'per', 'su', 'tra', 'fra', 'the', 'of', 'and', 'for', 'with'
  ];
  var CACHE_KEY = 'aycp-search-index-v6:' + config.indexUrl;
  var PAGE_RESULTS = 250;
  var DROPDOWN_RESULTS = 4;
  var SUGGESTED_GAMES = 4;
  var indexPromise = null;
  var indexTitles = {};

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/&[a-z0-9#]+;/g, ' ');
  }

  // Singolare e plurale: "anello" e "anelli" diventano "anell".
  function stem(word) {
    return word.length > 4 ? word.replace(/[aeio]$/, '') : word;
  }

  function tokenize(text) {
    return normalize(text).split(/[^a-z0-9]+/).filter(Boolean).map(stem);
  }

  // Le parole con numeri (es. "op18") non si accorciano: si cercano anche dentro i codici (vedi hasWord).
  function queryWords(query) {
    return normalize(query)
      .split(/[^a-z0-9]+/)
      .filter(function (word) {
        return word && STOP_WORDS.indexOf(word) === -1;
      })
      .map(function (word) {
        return /[0-9]/.test(word) ? word : stem(word);
      });
  }

  // Testo senza accenti e punteggiatura: "flat" con le parole separate da uno spazio, "compact" tutto attaccato.
  function flat(text) {
    return normalize(text).split(/[^a-z0-9]+/).filter(Boolean).join(' ');
  }

  function prepare(items) {
    items.forEach(function (item) {
      item.titleWords = tokenize(item.t);
      item.keyWords = tokenize(item.k);
      item.allWords = tokenize(item.t + ' ' + (item.k || '') + ' ' + item.x);
      item.titleFlat = ' ' + flat(item.t);
      item.titleCompact = item.titleFlat.replace(/ /g, '');
      item.keyCompact = flat(item.k).replace(/ /g, '');
      item.allCompact = flat(item.t + ' ' + (item.k || '') + ' ' + item.x).replace(/ /g, '');
      var tags = String(item.tg || '').split('|');
      item.stock = tags.indexOf('preorder') !== -1 ? 1 : item.a ? 0 : 2;
    });
    return items;
  }

  function fetchPage(page) {
    var separator = config.indexUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(config.indexUrl + separator + 'page=' + page, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('search index ' + response.status);
      return response.json();
    });
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        cached = JSON.parse(cached);
        indexTitles = cached.ct || {};
        indexPromise = Promise.resolve(prepare(cached.items || []));
        return indexPromise;
      }
    } catch (error) {
      /* sessionStorage non disponibile: si scarica e basta */
    }

    // Le prime 2 pagine insieme (oggi i prodotti stanno in 2 pagine), le eventuali altre dopo.
    var second = fetchPage(2).catch(function () {
      return { items: [] };
    });
    indexPromise = fetchPage(1)
      .then(function (first) {
        var pages = Math.min(first.pages || 1, 10);
        var requests = pages >= 2 ? [second] : [];
        for (var page = 3; page <= pages; page++) requests.push(fetchPage(page));
        return Promise.all(requests).then(function (rest) {
          var items = first.items || [];
          var titles = {};
          [first].concat(rest).forEach(function (result, index) {
            if (index > 0) items = items.concat(result.items || []);
            Object.keys(result.ct || {}).forEach(function (handle) {
              titles[handle] = result.ct[handle];
            });
          });
          indexTitles = titles;
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ items: items, ct: titles }));
          } catch (error) {
            /* spazio esaurito o non disponibile */
          }
          return prepare(items);
        });
      })
      .catch(function (error) {
        indexPromise = null;
        throw error;
      });

    return indexPromise;
  }

  // Una parola con numeri conta anche dentro il testo scritto tutto attaccato ("op18" trova "OP-18").
  function hasWord(words, word, compact) {
    for (var i = 0; i < words.length; i++) {
      if (words[i] === word || (word.length >= 3 && words[i].indexOf(word) === 0)) return true;
    }
    return !!compact && /[0-9]/.test(word) && compact.indexOf(word) !== -1;
  }

  function findProducts(items, query, limit) {
    var words = queryWords(query);
    if (!words.length) return [];
    var phrase = flat(query);
    var phraseCompact = /[0-9]/.test(phrase) ? phrase.replace(/ /g, '') : '';

    // Ordine: tutta la frase nel titolo, parole nel titolo, poi nel testo chiave (descrizione SEO),
    // poi disponibili, preordini, esauriti, poi i più recenti.
    var matches = [];
    items.forEach(function (item) {
      var inTitle = 0;
      var inKey = 0;
      for (var i = 0; i < words.length; i++) {
        if (!hasWord(item.allWords, words[i], item.allCompact)) return;
        if (hasWord(item.titleWords, words[i], item.titleCompact)) inTitle++;
        if (hasWord(item.keyWords, words[i], item.keyCompact)) inKey++;
      }
      var inPhrase =
        item.titleFlat.indexOf(' ' + phrase) !== -1 || (phraseCompact && item.titleCompact.indexOf(phraseCompact) !== -1) ? 1 : 0;
      matches.push({ item: item, inPhrase: inPhrase, inTitle: inTitle, inKey: inKey });
    });

    matches.sort(function (a, b) {
      return (
        b.inPhrase - a.inPhrase ||
        b.inTitle - a.inTitle ||
        b.inKey - a.inKey ||
        a.item.stock - b.item.stock ||
        b.item.d - a.item.d
      );
    });

    return matches.slice(0, limit).map(function (match) {
      return match.item;
    });
  }

  function escapeHtml(text) {
    return String(text || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function productUrl(item) {
    return config.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(item.h);
  }

  function imageUrl(item, width) {
    return item.i ? item.i.replace(/([?&])width=\d+/, '$1width=' + width) : '';
  }

  function priceHtml(item) {
    var strings = config.strings;
    var price = item.v ? strings.fromPrice.replace('[price]', item.p) : item.p;
    if (!item.c) {
      return (
        '<div class="price">' +
        '<div class="price__container"><div class="price__regular">' +
        '<span class="visually-hidden visually-hidden--inline">' + escapeHtml(strings.regularPrice) + '</span>' +
        '<span class="price-item price-item--regular">' + escapeHtml(price) + '</span>' +
        '</div></div></div>'
      );
    }
    return (
      '<div class="price price--on-sale">' +
      '<div class="price__container"><div class="price__sale">' +
      '<span class="visually-hidden visually-hidden--inline">' + escapeHtml(strings.regularPrice) + '</span>' +
      '<span><s class="price-item price-item--regular">' + escapeHtml(item.c) + '</s></span>' +
      '<span class="visually-hidden visually-hidden--inline">' + escapeHtml(strings.salePrice) + '</span>' +
      '<span class="price-item price-item--sale price-item--last">' + escapeHtml(price) + '</span>' +
      '</div></div></div>'
    );
  }

  function badgeHtml(item) {
    var strings = config.strings;
    if (!item.a) {
      return '<span class="badge badge--bottom-left color-' + config.soldOutScheme + '">' + escapeHtml(strings.soldOut) + '</span>';
    }
    if (item.c) {
      return '<span class="badge badge--bottom-left color-' + config.saleScheme + '">' + escapeHtml(strings.onSale) + '</span>';
    }
    return '';
  }

  // Pulsante sotto il prezzo, come in snippets/card-product.liquid ("b" e "vid" vengono dall'elenco dei prodotti).
  function buttonHtml(item) {
    var strings = config.strings;
    var style = escapeHtml(config.cardButtonStyle || '');
    var button;
    if (item.b === 'add' && item.vid && window.routes) {
      button =
        '<product-form>' +
        '<form method="post" action="' + escapeHtml(window.routes.cart_add_url) + '" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">' +
        '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="id" value="' + escapeHtml(item.vid) + '" class="product-variant-id">' +
        '<button type="submit" name="add" class="button button--full-width" style="' + style + '" aria-live="polite" data-sold-out-message="true">' +
        '<span>' + escapeHtml(strings.addToCart) + '</span>' +
        '<span class="sold-out-message hidden">' + escapeHtml(strings.soldOut) + '</span>' +
        '<div class="loading__spinner hidden">' + (config.spinner || '') + '</div>' +
        '</button></form></product-form>';
    } else {
      var label = { pre: strings.preorder, notify: strings.notifyMe, opt: strings.chooseOptions }[item.b];
      if (!label) return '';
      button = '<a href="' + escapeHtml(productUrl(item)) + '" class="button button--full-width" style="' + style + '">' + escapeHtml(label) + '</a>';
    }
    return '<div class="aycp-card-button" style="grid-row-start: 4; position: relative; z-index: 1; margin: 0 0 1rem;">' + button + '</div>';
  }

  // Il codice di Dawn per "Aggiungi al carrello", se la pagina non l'ha già caricato.
  function loadProductForm() {
    if (!config.productFormUrl || !window.customElements || customElements.get('product-form')) return;
    if (document.querySelector('script[data-search-fallback-product-form]')) return;
    var script = document.createElement('script');
    script.src = config.productFormUrl;
    script.defer = true;
    script.setAttribute('data-search-fallback-product-form', '');
    document.head.appendChild(script);
  }

  // Dati per la colonna dei filtri, come le schede di sections/main-search.liquid.
  function filterData(item) {
    var tags = String(item.tg || '');
    var state = tags.split('|').indexOf('preorder') !== -1 ? 'pre' : item.a ? 'avail' : 'sold';
    return (
      ' data-aycp-available="' + (item.a ? 'true' : 'false') + '"' +
      ' data-aycp-price="' + (parseInt(item.pc, 10) || 0) + '"' +
      ' data-aycp-sale="' + (item.s ? '1' : '0') + '"' +
      ' data-aycp-state="' + state + '"' +
      ' data-aycp-tags="' + escapeHtml(tags) + '"' +
      ' data-aycp-set="' + escapeHtml(item.st || '') + '"'
    );
  }

  function cardHtml(item, hidden) {
    var url = escapeHtml(productUrl(item));
    var title = escapeHtml(item.t);
    // Schede come le altre del sito: quadrate, foto intera (mai tagliata), fondo trasparente.
    var ratio = 100;
    var badge = badgeHtml(item);
    var media = item.i
      ? '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
        '<img src="' + escapeHtml(imageUrl(item, 533)) + '" srcset="' +
        escapeHtml(imageUrl(item, 360)) + ' 360w, ' + escapeHtml(imageUrl(item, 533)) + ' 533w, ' + escapeHtml(imageUrl(item, 720)) + ' 720w" ' +
        'sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" ' +
        'alt="" class="motion-reduce" style="object-fit: contain;" loading="lazy" width="' + (item.iw || 533) + '" height="' + (item.ih || 533) + '">' +
        '</div></div>'
      : '';

    return (
      '<li class="grid__item"' + filterData(item) + (hidden ? ' hidden' : '') + '>' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--' + config.cardStyle + (item.i ? ' card--media' : ' card--text') + '" style="--ratio-percent: ' + ratio + '%;">' +
      '<div class="card__inner color-' + config.cardScheme + ' gradient ratio" style="--ratio-percent: ' + ratio + '%; background: transparent;">' +
      media +
      '<div class="card__content"><div class="card__information"><h3 class="card__heading">' +
      '<a href="' + url + '" class="full-unstyled-link">' + title + '</a></h3></div>' +
      '<div class="card__badge ' + config.badgePosition + '">' + badge + '</div></div>' +
      '</div>' +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading h5"><a href="' + url + '" class="full-unstyled-link">' + title + '</a></h3>' +
      '<div class="card-information">' + priceHtml(item) + '</div></div>' +
      buttonHtml(item) +
      '<div class="card__badge ' + config.badgePosition + '">' + badge + '</div></div>' +
      '</div></div></li>'
    );
  }

  /* ---------- Pagina dei risultati ---------- */

  function fillSearchPage() {
    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').trim();
    if (!query || !/\/search\/?$/.test(window.location.pathname)) return;

    // Solo se Shopify non ha trovato prodotti: sections/main-search.liquid nasconde filtri e griglia con data-aycp-search-none.
    var layout = document.querySelector('[data-aycp-search-none]');
    var grid = document.getElementById('product-grid');
    if (!layout || !grid || grid.tagName !== 'UL' || grid.querySelector('.product-card-wrapper')) return;
    var container = grid.closest('[data-aycp-collection]');

    loadIndex()
      .then(function (items) {
        var found = findProducts(items, query, PAGE_RESULTS);
        if (!found.length) return;

        loadProductForm();

        // Si vedono "Prodotti per pagina" prodotti alla volta, gli altri con "Mostra di più".
        var step = (container && parseInt(container.getAttribute('data-aycp-step'), 10)) || 16;
        grid.innerHTML = found
          .map(function (item, index) {
            return cardHtml(item, index >= step);
          })
          .join('');
        var more = container ? container.querySelector('.aycp-show-more') : null;
        if (more) more.hidden = found.length <= step;

        layout.removeAttribute('data-aycp-search-none');
        var template = document.querySelector('.template-search');
        if (template) template.classList.remove('template-search--empty');

        // Come nella ricerca normale, sopra i prodotti non si scrive niente: si toglie il "Nessun risultato" di Shopify.
        var status = document.querySelector('.template-search__header p[role="status"]');
        if (status) status.remove();

        // Il numero dei risultati accanto a "Ordina per" / "Filtra" e nel pannello: quello dei prodotti trovati.
        if (container) {
          var text =
            found.length === 1
              ? container.getAttribute('data-aycp-results-one')
              : (container.getAttribute('data-aycp-results-other') || '').replace(/[0-9]+/, found.length);
          if (text) {
            ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
              var element = document.getElementById(id);
              if (element) element.textContent = text;
            });
            var drawerCount = layout.querySelector('.mobile-facets__count');
            if (drawerCount) drawerCount.textContent = text;
          }
        }
      })
      .catch(function () {
        /* se l'elenco non si scarica, resta la pagina normale */
      });
  }

  /* ---------- Tendina dei suggerimenti ---------- */

  // I giochi (collezioni) dei prodotti trovati, nell'ordine dei risultati, al massimo 4.
  function gamesOf(matches) {
    var titles = config.collectionTitles || {};
    var seen = {};
    var games = [];
    for (var i = 0; i < matches.length && games.length < SUGGESTED_GAMES; i++) {
      var handles = matches[i].g || [];
      for (var j = 0; j < handles.length && games.length < SUGGESTED_GAMES; j++) {
        var handle = handles[j];
        var title = titles[handle] || indexTitles[handle];
        if (seen[handle] || !title) continue;
        seen[handle] = true;
        games.push({ url: config.root.replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle), title: title });
      }
    }
    return games;
  }

  // Colonna "Suggerimenti" uguale a quella di Shopify (sections/predictive-search.liquid).
  function suggestionsHtml(games) {
    if (!games.length) return '';
    var items = games
      .map(function (game, index) {
        return (
          '<li id="predictive-search-option-collection-' + (index + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
          '<a href="' + escapeHtml(game.url) + '" class="predictive-search__item link link--text" tabindex="-1">' +
          '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
          '<p class="predictive-search__item-heading h5">' + escapeHtml(game.title) + '</p>' +
          '</div></a></li>'
        );
      })
      .join('');

    return (
      '<div class="predictive-search__result-group" data-search-fallback>' +
      '<div><h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">' +
      escapeHtml(config.strings.suggestions) +
      '</h2><ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries">' +
      items +
      '</ul></div></div>'
    );
  }

  // Righe dei prodotti come quelle di Shopify; "offset" per numerarle dopo quelle che ci sono già.
  function productItemsHtml(found, offset) {
    return found
      .map(function (item, index) {
        var thumb = item.i
          ? '<img class="predictive-search__image" src="' + escapeHtml(imageUrl(item, 150)) + '" alt="" width="50" height="' +
            Math.round(50 * ((item.ih || 1) / (item.iw || 1))) + '">'
          : '';
        return (
          '<li id="predictive-search-option-product-' + (offset + index + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false" data-search-fallback>' +
          '<a href="' + escapeHtml(productUrl(item)) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
          thumb +
          '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
          '<p class="predictive-search__item-heading h5">' + escapeHtml(item.t) + '</p>' +
          '</div></a></li>'
        );
      })
      .join('');
  }

  function dropdownHtml(found) {
    var items = productItemsHtml(found, 0);

    return (
      '<div class="predictive-search__result-group" data-search-fallback>' +
      '<div><h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">' +
      escapeHtml(config.strings.dropdownHeading) +
      '</h2><ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">' +
      items +
      '</ul></div></div>'
    );
  }

  // Le parole cercate scritte per intero nel titolo (senza accorciarle): "dominio" sì in "Dominio Delta", no in "Dominion".
  function wholeWords(title, query) {
    var words = flat(title).split(' ');
    var wanted = normalize(query)
      .split(/[^a-z0-9]+/)
      .filter(function (word) {
        return word && STOP_WORDS.indexOf(word) === -1;
      });
    return (
      wanted.length > 0 &&
      wanted.every(function (word) {
        return words.indexOf(word) !== -1;
      })
    );
  }

  function handleOf(href) {
    var match = String(href || '').match(/\/products\/([^?#\/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  // Shopify ha trovato meno di 4 prodotti: i posti liberi si riempiono con i prodotti che hanno nel titolo italiano tutte le
  // parole cercate e che Shopify non ha messo. Vanno in cima se hanno le parole intere nel titolo e quelli di Shopify no.
  function fillDropdown(predictiveSearch, list, term) {
    if (list.children.length >= DROPDOWN_RESULTS) return;

    loadIndex()
      .then(function (items) {
        if (predictiveSearch.getQuery() !== term || !list.isConnected || list.querySelector('[data-search-fallback]')) return;

        var rows = Array.prototype.slice.call(list.children);
        var shown = {};
        var shopifyWhole = false;
        rows.forEach(function (row) {
          var link = row.querySelector('a[href]');
          if (link) shown[handleOf(link.getAttribute('href'))] = true;
          var heading = row.querySelector('.predictive-search__item-heading');
          if (heading && wholeWords(heading.textContent, term)) shopifyWhole = true;
        });

        var words = queryWords(term);
        var found = findProducts(items, term, PAGE_RESULTS)
          .filter(function (item) {
            return (
              !shown[item.h] &&
              words.every(function (word) {
                return hasWord(item.titleWords, word, item.titleCompact);
              })
            );
          })
          .slice(0, DROPDOWN_RESULTS - rows.length);
        if (!found.length) return;

        var onTop = !shopifyWhole && wholeWords(found[0].t, term);
        list.insertAdjacentHTML(onTop ? 'afterbegin' : 'beforeend', productItemsHtml(found, rows.length));
      })
      .catch(function () {
        /* se l'elenco non si scarica, resta la tendina di Shopify */
      });
  }

  function addToDropdown(predictiveSearch, term) {
    var results = predictiveSearch.querySelector('#predictive-search-results');
    if (!results) return;
    var shopifyList = results.querySelector('#predictive-search-results-products-list');
    if (shopifyList) {
      fillDropdown(predictiveSearch, shopifyList, term);
      return;
    }

    loadIndex()
      .then(function (items) {
        if (predictiveSearch.getQuery() !== term) return;
        if (results.querySelector('#predictive-search-results-products-list')) return;

        var matches = findProducts(items, term, PAGE_RESULTS);
        if (!matches.length) return;
        var found = matches.slice(0, DROPDOWN_RESULTS);

        var wrapper = results.querySelector('#predictive-search-results-groups-wrapper');
        if (wrapper) {
          // Shopify ha gia' i suggerimenti: si aggiungono solo i prodotti.
          wrapper.classList.remove('predictive-search__results-groups-wrapper--no-products');
          wrapper.insertAdjacentHTML('beforeend', dropdownHtml(found));
        } else {
          // Shopify non ha trovato niente: accanto ai prodotti anche i "Suggerimenti" con i loro giochi.
          var suggestions = suggestionsHtml(gamesOf(matches));
          var html =
            '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper' +
            (suggestions ? '' : ' predictive-search__results-groups-wrapper--no-suggestions') +
            '">' +
            suggestions +
            dropdownHtml(found) +
            '</div>';
          var anchor = results.querySelector('.predictive-search__loading-state') || results.querySelector('#predictive-search-option-search-keywords');
          if (anchor) {
            anchor.insertAdjacentHTML('beforebegin', html);
          } else {
            results.insertAdjacentHTML('afterbegin', html);
          }
        }
      })
      .catch(function () {
        /* se l'elenco non si scarica, resta la tendina normale */
      });
  }

  function patchPredictiveSearch() {
    if (typeof PredictiveSearch === 'undefined' || PredictiveSearch.prototype.__searchFallback) return;
    var originalRender = PredictiveSearch.prototype.renderSearchResults;
    PredictiveSearch.prototype.renderSearchResults = function (resultsMarkup) {
      originalRender.call(this, resultsMarkup);
      addToDropdown(this, this.getQuery());
    };
    PredictiveSearch.prototype.__searchFallback = true;
  }

  /* ---------- Avvio ---------- */

  // Scarica l'elenco in anticipo quando il cliente tocca una barra di ricerca.
  document.addEventListener('focusin', function (event) {
    if (event.target && event.target.matches && event.target.matches('input[type="search"]')) {
      loadIndex().catch(function () {});
    }
  });

  patchPredictiveSearch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillSearchPage);
  } else {
    fillSearchPage();
  }
})();
